import { useSelector } from 'react-redux'
import { CheckCircleIcon, BuildingOfficeIcon, AcademicCapIcon, EyeIcon, ExclamationCircleIcon } from "@heroicons/react/24/outline"
import Cookies from "universal-cookie";

import { useEffect, useState, memo } from 'react'

import { fetchApi } from "../tools" // Consumir api
import WarningModal from '../components-modals/WarningModal.js'
import Moodle from '../moodle/Moodle.js';

const InformacionAlumno = ({ datos = [], moverIni, foto = false, saludo = true, setEtapaPago, etapaPago=false }) => {

    const Fotov1 = useSelector(state => state.auth.Fotov)
    const user = useSelector(state => state.auth.user)
    const userObj = JSON.parse(user)

    const Fotov = (!foto ? Fotov1 : datos.Fotov)

    const [passMoodle, setPassMoodle] = useState('')
    const [carnetMoodle, setCarnetMoodle] = useState('')

    const [showmoodle, setShowMoodle] = useState(false)

    const cookies = new Cookies()
    //const url = cookies.get('__urlSchoolApi') // url para enviar al api viene de cookies
    const urlState = useSelector(state => state.url.urlSchoolApi)
    const url = urlState === '' || urlState === undefined || urlState === null ? cookies.get("__urlSchoolApi") : urlState

    const { headersAPI: headers } = useSelector(state => state.url) // Headers para enviar al api viene de redux

    const [loading, setLoading] = useState(false)

    //Manejo de errores
    const [modal, setModal] = useState({
        show: false,
        msg: '',
        ok: false,
    })

    const handleMoodle = async (Carnet) => {
        try {
            setLoading(true)

            const data = await fetchApi({
                url: url + '/perfilalumno/perfildeuda',
                headers,
                content: {
                    Carnet
                }
            })

            //console.log(data.diasv2)

            if (data.diasv2 < 1) {
                const dataMoodle = await fetchApi({
                    url: url + '/perfilalumno/passwordmoodle',
                    headers,
                    content: {
                        Carnet
                    }
                })
                setPassMoodle(dataMoodle.msg[0].Mensaje)
                setCarnetMoodle(Carnet)
                setShowMoodle(true)
            } else {
                setModal({
                    msg: 'Hay un problema con tu conexión en el servidor, por favor comunícate con tu director.',
                    ok: false,
                    show: true
                })
                setPassMoodle('')
                setCarnetMoodle('')
                setShowMoodle(false)
            }
            setLoading(false)
            moverIni()
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        //console.log('datos', datos)
        //
        if(etapaPago){
            setEtapaPago(false)
        }
    }, [])

    return (
        <>
            <WarningModal
                open={loading ? true : false}
                image={<img src='./img/loader.gif' alt='loading' />}
                opacity='bg-opacity-100'
            />
            <WarningModal
                open={modal.show ? true : false}
                image={
                    modal.ok
                        ? <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto" />
                        : <ExclamationCircleIcon className="h-20 w-20 text-secundario mx-auto" />
                }
                title='Aviso'
                subtitle={<span>{modal.msg}</span>}
                opacity='bg-opacity-50'
            >
                <div className="mt-5 sm:mt-6">
                    <button
                        onClick={() => {
                            if (modal.reload) {
                                window.location.reload()
                            }
                            setModal(curr => ({
                                ...curr, show: false, reload: false
                            }))
                        }}
                        type="button"
                        className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
                    >
                        Entendido
                    </button>
                </div>
            </WarningModal>
            {showmoodle &&
                <Moodle
                    Carnet={carnetMoodle}
                    password={passMoodle}
                    setShowMoodle={setShowMoodle}
                />
            }
            <div className="bg-primarioMira rounded-2xl shadow-sm shadow-white">
                <div className="px-14 py-4 mt-4 lg:flex lg:items-center lg:justify-between grid grid-cols-1 gap-x-6 gap-y-8 lg:grid-cols-2 xl:gap-x-8">
                    <div className="min-w-0 flex-1">
                        {/* Profile */}
                        <div className="flex items-center">
                            <img
                                className="hidden h-32 w-32 rounded-full sm:block"
                                src={Fotov}
                                alt=""
                            />
                            <div>
                                <div className="flex items-center">
                                    <img
                                        className="h-16 w-16 rounded-full sm:hidden"
                                        src={Fotov}
                                        alt=""
                                    />
                                    <h1 className="ml-3 text-2xl font-bold leading-7 text-white sm:truncate sm:leading-9">
                                        {saludo ? datos.Saludo: ''}{saludo ? ',' : ''} {datos.Alumno}
                                    </h1>
                                </div>
                                <dl className="mt-6 flex flex-col sm:ml-3 sm:mt-1 sm:flex-row sm:flex-wrap">
                                    <dt className="sr-only">Campus</dt>
                                    <dd className="flex items-center text-base font-medium capitalize text-grisMira sm:mr-6">
                                        <BuildingOfficeIcon
                                            className="mr-1.5 h-5 w-5 flex-shrink-0 text-secundario"
                                            aria-hidden="true"
                                        />
                                        Campus {datos.Sede}
                                    </dd>
                                    <dt className="sr-only">Email status</dt>
                                    <dd className="mt-3 flex items-center text-base font-medium capitalize text-grisMira sm:mr-6 sm:mt-0">
                                        <CheckCircleIcon
                                            className="mr-1.5 h-5 w-5 flex-shrink-0 text-green-300"
                                            aria-hidden="true"
                                        />
                                        Email Verificado
                                    </dd>
                                    <dt className="sr-only">Celular status</dt>
                                    <dd className="mt-3 flex items-center text-base font-medium text-grisMira sm:mr-6 sm:mt-0">
                                        <CheckCircleIcon
                                            className="mr-1.5 h-5 w-5 flex-shrink-0 text-green-300"
                                            aria-hidden="true"
                                        />
                                        No. de Celular Verificado
                                    </dd>
                                </dl>
                                <dl className="mt-6 flex flex-col sm:ml-3 sm:mt-1 sm:flex-row sm:flex-wrap">
                                    <dt className="sr-only">Grado</dt>
                                    <dd className="flex items-center text-base font-medium capitalize text-grisMira sm:mr-6">
                                        <AcademicCapIcon
                                            className="mr-1.5 h-5 w-5 flex-shrink-0 text-secundario"
                                            aria-hidden="true"
                                        />
                                        {datos.Grado}
                                    </dd>
                                    <dt className="sr-only">Seccion</dt>
                                    <dd className="flex items-center text-base font-medium capitalize text-grisMira sm:mr-6">
                                        Sección {datos.Seccion}
                                    </dd>
                                </dl>
                            </div>
                        </div>
                        <dl className="mt-6 flex flex-col sm:ml-3 sm:mt-1 sm:flex-row sm:flex-wrap">
                            <dt className="sr-only">Carnet</dt>
                            <dd className="flex items-center text-xl font-semibold capitalize text-white sm:mr-6">
                                Carnet {datos.Carnet}
                            </dd>
                        </dl>
                    </div>
                    <div className='flex flex-col'>
                        <ul role="list" className="bg-secundarioMira rounded-xl border border-secundarioMira shadow-md shadow-secundarioMiral">
                            <dl className="px-4 py-4 text-base leading-6">
                                <div className="flex justify-center text-center gap-4">
                                    <EyeIcon
                                        className='h-6 w-6 text-secundario'
                                        aria-hidden="true"
                                    />
                                    <dt className="text-white">Última visita</dt>
                                    <dd className="text-grisMira font-semibold">{datos.FechaVisita}</dd>
                                </div>
                                <div className="flex justify-center text-center gap-4">
                                    <dt className="text-white">Hora:</dt>
                                    <div className="text-grisMira font-semibold">{datos.HoraVisita}</div>
                                </div>
                            </dl>
                        </ul>
                        <div className='mt-4'>
                            <button
                                onClick={() => handleMoodle(datos.Carnet)}
                                type="button"
                                className="flex-initial w-full rounded-md border border-transparent bg-azulBrillanteMira py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-secundarioMira hover:border-azulLogos hover:border-2 focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2"
                            >
                                <div className="flex justify-center">
                                    <AcademicCapIcon className="h-5 w-5 text-white" aria-hidden="true" />
                                    <p className="ml-1 px-2">Accede a tus cursos</p>
                                </div>
                            </button>
                        </div>
                    </div>
                </div >
            </div >
        </>
    )
}

export default memo(InformacionAlumno)